/**
 * Marketing + app URLs for blog chrome.
 * Dev blog (dev.kramasoft.com) → qa.dev.* marketing sites.
 * Stage blog → qa.stage.* marketing sites.
 */
const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/cliqloan",
  facebook: "https://www.facebook.com/people/CliQloan-US/pfbid025B5zAvPiDs1QWMdgPtQV9CxvVdkjx9MJgtFm84k18Ht4qackBBKnSx98oiWhCrygl/",
};

function resolveUrlsFromBuildEnv() {
  const landing = (process.env.REACT_APP_LANDING_URL || process.env.REACT_APP_BASE_URL || '').toLowerCase();
  if (!landing) return null;
  if (landing.includes('dev.kramasoft') || landing.includes('qa.dev.cliqloan')) {
    return devMarketingUrls();
  }
  if (landing.includes('stage.cliqloan') || landing.includes('qa.stage.cliqloan')) {
    return stageMarketingUrls();
  }
  if (landing.includes('cliqloan.com') && !landing.includes('qa.')) {
    return prodMarketingUrls();
  }
  return null;
}

export function getCliqloanSiteUrls() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();

    if (
      host.includes("dev.kramasoft") ||
      host.includes("qa.dev.cliqloan") ||
      host.includes("dev.cliqloan") ||
      host.includes("frontend-dev.cliqloan")
    ) {
      return devMarketingUrls();
    }

    if (host.includes("stage.cliqloan") || host.includes("qa.stage.cliqloan")) {
      return stageMarketingUrls();
    }

    if (host.includes("app.cliqloan") || (host.includes("cliqloan.com") && !host.includes("qa."))) {
      return prodMarketingUrls();
    }
  }

  return resolveUrlsFromBuildEnv() || devMarketingUrls();
}

function devMarketingUrls() {
  const base = "https://qa.dev.cliqloan.com";
  return {
    marketingHome: base,
    homeHero: `${base}/#hero`,
    aboutUs: `${base}/about`,
    products: `${base}/#products`,
    ourProducts: `${base}/our-products`,
    verificationEngine: `${base}/verification-engine`,
    disclosureHub: `${base}/our-products`,
    complianceMonitor: `${base}/our-products`,
    mortgageBrokerSoftware: `${base}/mortgage-broker-software`,
    mortgagePointOfSale: `${base}/mortgage-point-of-sale`,
    loanOfficerWebsite: `${base}/loan-officer-website`,
    borrowerPortal: "https://borrower.cliqloan.com/",
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    glossary: `${base}/glossary`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/terms-conditions`,
    privacyPolicy: `${base}/privacy-policy`,
    apiContactUs: "https://dev.kramasoft.com/ks/api/v1/admin/contact-us",
    apiScheduleDemo: "https://dev.kramasoft.com/ks/api/v1/admin/demo-schedule",
    signIn: "https://dev.kramasoft.com/signin",
    signUp: "https://dev.kramasoft.com/signup",
    blogHome: "/blog",
    blogPublicUrl: "https://dev.kramasoft.com/blog",
    cliqloanHome: "https://qa.dev.cliqloan.com",
    amitasoftHome: "https://qa.dev.amitasoft.com",
    safevaultHome: "https://qa.dev.safevaultusa.com",
    social: SOCIAL,
  };
}

function stageMarketingUrls() {
  const base = "https://qa.stage.cliqloan.com";
  return {
    marketingHome: base,
    homeHero: `${base}/#hero`,
    aboutUs: `${base}/about`,
    products: `${base}/#products`,
    ourProducts: `${base}/our-products`,
    verificationEngine: `${base}/verification-engine`,
    disclosureHub: `${base}/our-products`,
    complianceMonitor: `${base}/our-products`,
    mortgageBrokerSoftware: `${base}/mortgage-broker-software`,
    mortgagePointOfSale: `${base}/mortgage-point-of-sale`,
    loanOfficerWebsite: `${base}/loan-officer-website`,
    borrowerPortal: "https://borrower.cliqloan.com/",
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    glossary: `${base}/glossary`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/terms-conditions`,
    privacyPolicy: `${base}/privacy-policy`,
    apiContactUs: "https://stage.cliqloan.com/ks/api/v1/admin/contact-us",
    apiScheduleDemo: "https://stage.cliqloan.com/ks/api/v1/admin/demo-schedule",
    signIn: "https://stage.cliqloan.com/signin",
    signUp: "https://stage.cliqloan.com/signup",
    blogHome: "/blog",
    blogPublicUrl: "https://stage.cliqloan.com/blog",
    cliqloanHome: "https://qa.stage.cliqloan.com",
    amitasoftHome: "https://qa.stage.amitasoft.com",
    safevaultHome: "https://qa.stage.safevaultusa.com",
    social: SOCIAL,
  };
}

function prodMarketingUrls() {
  const base = "https://www.cliqloan.com";
  return {
    marketingHome: base,
    homeHero: `${base}/#hero`,
    aboutUs: `${base}/about`,
    products: `${base}/#products`,
    ourProducts: `${base}/our-products`,
    verificationEngine: `${base}/verification-engine`,
    disclosureHub: `${base}/our-products`,
    complianceMonitor: `${base}/our-products`,
    mortgageBrokerSoftware: `${base}/mortgage-broker-software`,
    mortgagePointOfSale: `${base}/mortgage-point-of-sale`,
    loanOfficerWebsite: `${base}/loan-officer-website`,
    borrowerPortal: "https://borrower.cliqloan.com/",
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    glossary: `${base}/glossary`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/terms-conditions`,
    privacyPolicy: `${base}/privacy-policy`,
    apiContactUs: "https://app.cliqloan.com/ks/api/v1/admin/contact-us",
    apiScheduleDemo: "https://app.cliqloan.com/ks/api/v1/admin/demo-schedule",
    signIn: "https://app.cliqloan.com/signin",
    signUp: "https://app.cliqloan.com/signup",
    blogHome: "/blog",
    blogPublicUrl: "https://www.cliqloan.com/blog",
    cliqloanHome: "https://www.cliqloan.com",
    amitasoftHome: "https://www.amitasoft.com",
    safevaultHome: "https://www.safevaultusa.com",
    social: SOCIAL,
  };
}
